export default "__VITE_ASSET__DUInV1OF__"